import React from "react";
import { getCpapTrialDaysLate } from "./cpapTrialDashboardDateUtils";

export const summarizeOverdueCpapModels = (cpaps, now = new Date()) => {
  const models = new Map();
  let total = 0;
  let dueToday = 0;

  cpaps.forEach((cpap) => {
    const daysLate = getCpapTrialDaysLate(cpap.LastDueDate, now);
    if (daysLate === 0) dueToday += 1;
    if (!(daysLate > 0)) return;

    const model = String(cpap.Model || "").trim().replace(/\s+/g, " ") || "ไม่ระบุ Model";
    const key = model.toLowerCase();
    const entry = models.get(key) || { model, count: 0 };
    entry.count += 1;
    models.set(key, entry);
    total += 1;
  });

  return {
    total,
    dueToday,
    models: Array.from(models.values()).sort((left, right) =>
      right.count - left.count || left.model.localeCompare(right.model)),
  };
};

const CpapTrialOverdueSummary = ({ cpaps, now }) => {
  const summary = summarizeOverdueCpapModels(cpaps, now);
  return (
    <section className="dashboard-cpap-summary mb-3" aria-label="สรุปเครื่องเลยกำหนดคืนแยกตาม Model">
      <div className="d-flex flex-wrap align-items-baseline mb-2">
        <h6 className="mb-1 mr-3">สรุปตาม Model</h6>
        <strong className="text-danger mr-3">เลยกำหนดทั้งหมด {summary.total} เครื่อง</strong>
        {summary.dueToday > 0 && (
          <small className="text-muted">ครบกำหนดวันนี้ {summary.dueToday} เครื่อง</small>
        )}
      </div>
      {summary.models.length > 0 ? (
        <dl className="dashboard-cpap-models mb-0">
          {summary.models.map(({ model, count }) => (
            <div key={model} className="dashboard-cpap-model">
              <dt>{model}</dt>
              <dd className="mb-0"><strong>{count}</strong> เครื่อง</dd>
            </div>
          ))}
        </dl>
      ) : (
        <small className="text-muted">ไม่มีเครื่องเลยกำหนดคืน</small>
      )}
    </section>
  );
};

export default CpapTrialOverdueSummary;
